export function get(obj, path) {
  return path.reduce(function (acc, step) {
    return acc === null || acc === void 0 ? void 0 : acc[step];
  }, obj);
}